<div *ngIf="svincoliDownloadComplete">
  <div *ngIf="!serverError; else errorBlock">
    <div *ngIf="erroreGestitoMex == null; else erroreGestitoBlock">
      <div
        class="dashboard-table-wrapper"
        *ngIf="svincoliPresenti; else noSvincoliBlock">
        <ds-table
          class="dashboard-table"
          [tableConfig]="tableConfig"
          [attr.table-empty-title]="'emptyTableTitle' | translate"
          [attr.table-empty-description]="'emptyTableDescription' | translate"
          [attr.table-empty-image-url]="emptyImage"
          [attr.table-empty-image-alt]="'emptyTableAltImage' | translate"
          (onClickSecondRightAction)="
            onSecondRightIconClick($event)
          "></ds-table>
      </div>
      <ng-template #noSvincoliBlock>
        <div>
          <app-no-element [isDocument]="false"></app-no-element>
        </div>
      </ng-template>
    </div>
    <ng-template #erroreGestitoBlock>
      <div>
        <app-no-element [isDocument]="false"></app-no-element>
      </div>
    </ng-template>
  </div>
  <ng-template #errorBlock>
    <div>
      <app-no-element [isDocument]="false"></app-no-element>
    </div>
  </ng-template>
</div>

<ds-spinner
  *ngIf="!svincoliDownloadComplete"
  [attr.spinner-ui-variant]="'spinner'"
  [attr.spinner-aria-label]="'Caricamento' | translate"></ds-spinner>
